import { defineComponent as _defineComponent } from 'vue'
import { FireOutbreak } from '@/@core/fire-risk-dashboard/domain/entities/FireOutbreak'
import FireOutbreakReactionFactory from './FireOutbreakReaction.factory.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'FireOutbreakTooltip',
  props: {
    alert: null
  },
  setup(__props: any) {



return { __sfc: true,FireOutbreakReactionFactory }
}

})